<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="title"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
      class="app-main-inner afr-edi-bill-search-selector"
      @close="cancel()"
    >
      <div class="app-main-inner-row">
        <el-form label-width="100px" label-position="left">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="HBL NO">
                <el-input v-model="hblNo" style="width: 220px;" no="1" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('SeaExport.ConsignationCompany')">
                <cargo-company-select
                  :method-params="{customer:true}"
                  :default-value="customerId"
                  style="width: 220px"
                  no="2"
                  @change="p=>{customerId=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="JOB NO">
                <el-input v-model="jobNo" style="width: 220px;" no="3" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col v-if="customerType === 'shipper'" :span="8">
              <el-form-item label="Shipper">
                <el-input v-model="shipper" style="width: 220px;" no="4" />
              </el-form-item>
            </el-col>
            <el-col v-if="customerType === 'consignee'" :span="8">
              <el-form-item label="Consignee">
                <el-input v-model="consignee" style="width: 220px;" no="5" />
              </el-form-item>
            </el-col>
            <el-col v-if="customerType === 'notify'" :span="8">
              <el-form-item label="Notify Party">
                <el-input v-model="notify" style="width: 220px;" no="6" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item>
                <el-button style="margin-left: -60px;" type="primary" :title="$t('queryJob.Search')" no="7" @click="searchHandler">Search</el-button>
                <el-button type="primary" :title="$t('queryJob.Clear')" no="8" @click="reset">Clearing</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="app-main-inner-row row-grid" style="min-height:350px;padding:0">
        <cargo-ag-grid
          v-if="innerVisible"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width:100%;height:350px;"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
      <div class="app-main-inner-row row-pagination">
        <cargo-pagination
          v-if="innerVisible"
          v-show="searchConditions.total>0"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="searchHandler"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" no="9" @click="confirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="10" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { searchAfrAddress } from '@/api/seaExport/cargoDoc'
import { getLoading } from '@/utils/utilBaseElement'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'YfAfrAddressDialog',
  components: { cargoCompanySelect },
  props: {
    visible: { type: Boolean, required: true },
    noLabel: { type: String, default: '' },
    params: { type: Object, default: () => {} },
    noTitle: { type: String, default: '' },
    customerType: { type: String, default: '' } // 收发通客户类型 shipper、consignee、notify
  },
  data() {
    return {
      innerVisible: false,
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      hblNo: '',
      customerId: 0,
      jobNo: '',
      shipper: '',
      consignee: '',
      notify: '',
      chooseRows: null,
      rowData: [],
      commonColumnDefs: [
        { headerName: 'HBL NO', field: 'hblNbr2', width: 200, flex: 1 },
        { headerName: 'JOB NO', field: 'jobNo', width: 200, flex: 1 },
        {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          width: 200,
          flex: 1,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }
      ],
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        onRowClicked: (e) => { this.chooseRows = e.data }
      },
      title: ''
    }
  },
  computed: {
    columnDefs() {
      const columnDefs = []
      if (this.customerType === 'shipper') {
        columnDefs.push({
          headerName: 'Shipper',
          headerTooltip: this.$t('queryJob.ShipperName'),
          field: 'shipperLine1',
          width: 200,
          flex: 1,
          tooltip: params => params.value
        })
      } else if (this.customerType === 'consignee') {
        columnDefs.push({
          headerName: 'Consignee',
          headerTooltip: this.$t('queryJob.ConsigneeName'),
          field: 'consigneeLine1',
          width: 200,
          flex: 1,
          tooltip: params => params.value
        })
      } else if (this.customerType === 'notify') {
        columnDefs.push({
          headerName: 'Notify Party',
          headerTooltip: this.$t('queryJob.NotifyPartyName'),
          field: 'notifyLine1',
          width: 200,
          flex: 1,
          tooltip: params => params.value
        })
      }
      columnDefs.push(...this.commonColumnDefs)
      return columnDefs
    }
  },
  watch: {
    visible: {
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          if (this.params) {
            this.shipper = this.params.shipper
            this.consignee = this.params.consignee
            this.notify = this.params.notify
            this.searchHandler()
          }
        }
      },
      immediate: true
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    },
    customerType: {
      async handler(newVal) {
        if (newVal === 'shipper') {
          this.title = 'Search Shipper'
        } else if (newVal === 'consignee') {
          this.title = 'Search Consignee'
        } else if (newVal === 'notify') {
          this.title = 'Search Notify Party'
        }
      },
      immediate: true
    }
  },
  methods: {
    searchHandler() {
      if (this.gridApi) {
        this.gridApi.clearFocusedCell() // 清除选中行
      }
      this.loading = getLoading()
      const params = {}
      params.branchId = this.$store.getters.currentOfficeId
      params.pageNum = this.searchConditions.pageNum
      params.pageSize = this.searchConditions.pageSize
      params.hblNbr2 = this.hblNo
      params.customerId = this.customerId
      params.jobNo = this.jobNo
      params.shipper = this.shipper ? this.shipper.trim() : this.shipper
      params.consignee = this.consignee ? this.consignee.trim() : this.consignee
      params.notify = this.notify ? this.notify.trim() : this.notify
      params.docType = this.params.docType
      searchAfrAddress(params).then(result => {
        this.rowData = result.data.list
        this.searchConditions.total = parseInt(result.data.total)
      }).catch(message => {
        this.$message.error(message)
      }).finally(() => {
        this.chooseRows = null
        this.loading.close()
      })
    },
    reset() {
      this.hblNo = ''
      this.customerId = ''
      this.jobNo = ''
      this.shipper = ''
      this.consignee = ''
      this.notify = ''
      this.searchConditions = {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    },
    confirm() {
      if (!this.chooseRows) {
        return
      }
      this.chooseRows.customerType = this.customerType
      this.$emit('selected', this.chooseRows)
      this.innerVisible = false
    },
    cancel() {
      this.innerVisible = false
      this.rowData = []
      this.reset()
    }
  }
}
</script>

<style lang="scss" scoped>
  .afr-edi-bill-search-selector {
    label {
      font-size: 12px;
      font-weight: normal;
    }
    .el-select {
      width: 100%;
    }
  }
</style>
